export default {"src":"/_next/static/media/main_ilu.ca8e8ca3.svg","height":1029,"width":1066,"blurWidth":0,"blurHeight":0};